import { useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";
import { IS_DEV } from "@/domains/main/constants/other.ts";
import { NotificationEvent } from "@/domains/notification/constants/event";
import { NotificationState } from "@/domains/notification/constants/notificationState";
import { NotificationType } from "@/domains/notification/constants/notificationType";
import { fakeNotifications } from "@/domains/notification/helpers/fakeNotifications";

type State = {
  type: NotificationType;
  state: NotificationState;
};

export default function useShowNotification() {
  const [queue, setQueue] = useState<State[]>(IS_DEV ? (fakeNotifications as State[]) : []);
  const [notification, setNotification] = useState<State | null>(
    IS_DEV
      ? {
          type: NotificationType.PlayerLevel,
          state: {
            level: 4,
            increase: true,
            points: [10, 20],
          },
        }
      : null,
  );

  useEffect(() => {
    if (notification) {
      const timeout = setTimeout(() => {
        setNotification(null);
      }, 5000);

      return () => {
        clearTimeout(timeout);
      };
    }

    if (queue.length) {
      const timeout = setTimeout(() => {
        const nextNotification = queue[0];
        setQueue((state) => state.slice(1));
        setNotification(nextNotification);
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }

    return () => {};
  }, [notification, queue]);

  useEffect(() => {
    rpc.register(NotificationEvent.SetShowNotification, (args: State): void => {
      setQueue((state) => [...state, args]);
    });

    return () => {
      rpc.unregister(NotificationEvent.SetShowNotification);
    };
  }, []);

  return {
    notification,
  };
}
